import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class WorkshopSearchModal extends Component {
  render() {
    return (
      this.props.showWorkshopSearchModal && (
        <React.Fragment>
          <div className="section-steps__edit-container showResume">
            <div className="container">
              <div className="row">
                <div className="col-md-1" />
                <div className="col-xs-12 col-md-10">
                  <div className="section-steps__edit-content">
                    <div className="section-steps__resume-header">
                      <div className="resume-header__title">
                        <span>Instalaciones disponibles</span>
                        <span className="resume-header__link">
                          <Link
                            to="/"
                            className="link link--red"
                            onClick={() => {
                              this.props.modalWorkshopSearchToggle();
                              this.props.resetStateTo1();
                            }}
                          >
                            Modificar
                          </Link>
                        </span>
                      </div>
                      <div
                        className="resume-header__close"
                        onClick={this.props.modalWorkshopSearchToggle}
                      >
                        X
                      </div>
                    </div>
                    <div className="section-steps__resume-content">
                      <div className="resume-header__block">
                        <div className="resume-header__block-title">
                          Código Postal
                        </div>
                        <div className="resume-header__block-info">
                          {this.props.selectedWorkshops.DealershipZipCode}
                        </div>
                      </div>
                      <div className="resume-header__block">
                        <div className="resume-header__block-title">
                          Instalación seleccionada
                        </div>
                        <div className="resume-header__block-info">
                          {this.props.selectedWorkshops.DealershipName}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    );
  }
}
